import { useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

const VIDEO_SRC =
  "https://www.youtube.com/embed/Q82jmn-eMk0?autoplay=1&rel=0&modestbranding=1";

export default function VideoModal({ open, onOpenChange }) {
  // Escape hardening: the YouTube iframe can swallow keydown once focused.
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onOpenChange(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onOpenChange]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="video-modal"
        className="max-w-3xl overflow-hidden border-hairline bg-bg-surface p-0"
      >
        <DialogTitle className="sr-only">RelayOps demo</DialogTitle>
        <DialogDescription className="sr-only">
          A walkthrough of the RelayOps AI ops layer.
        </DialogDescription>
        <div className="flex items-center justify-between border-b border-hairline px-5 py-3">
          <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink-muted">
            RelayOps · product demo
          </span>
        </div>
        <div className="aspect-video w-full bg-black">
          {open && (
            <iframe
              data-testid="video-iframe"
              className="h-full w-full"
              src={VIDEO_SRC}
              title="RelayOps demo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
